const Waves = () => {
  return (
    <div id="waves"></div>
  );
}

export default Waves;